import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import Banner from './Banner';
var StickyBanner = /*#__PURE__*/function (_React$Component) {
  function StickyBanner(props) {
    var _this;
    _classCallCheck(this, StickyBanner);
    _this = _callSuper(this, StickyBanner, [props]);
    _defineProperty(_this, "observer", void 0);
    _this.close = _this.close.bind(_this);
    _this.state = {
      toShow: false
    };
    return _this;
  }
  _inherits(StickyBanner, _React$Component);
  return _createClass(StickyBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupObserver(this.props.refElement);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$refElement, _this$props$refElemen;
      if (((_prevProps$refElement = prevProps.refElement) === null || _prevProps$refElement === void 0 || (_prevProps$refElement = _prevProps$refElement.current) === null || _prevProps$refElement === void 0 || (_prevProps$refElement = _prevProps$refElement.dataset) === null || _prevProps$refElement === void 0 ? void 0 : _prevProps$refElement.op) !== ((_this$props$refElemen = this.props.refElement) === null || _this$props$refElemen === void 0 || (_this$props$refElemen = _this$props$refElemen.current) === null || _this$props$refElemen === void 0 || (_this$props$refElemen = _this$props$refElemen.dataset) === null || _this$props$refElemen === void 0 ? void 0 : _this$props$refElemen.op)) {
        this.setupObserver(this.props.refElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }, {
    key: "setupObserver",
    value: function setupObserver(refElement) {
      var _this2 = this;
      if (this.observer) {
        this.observer.disconnect();
      }
      if (refElement && refElement.current) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            _this2.setState(function () {
              return {
                toShow: entry.boundingClientRect.top < 0 && !entry.isIntersecting
              };
            });
          });
        }, {
          rootMargin: '5px',
          threshold: 0
        });
        this.observer.observe(refElement.current);
      } else {
        // to disaply the component if refElement is not passed
        this.setState(function () {
          return {
            toShow: true
          };
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.observer && this.props.refElement) {
        this.observer.unobserve(this.props.refElement.current);
        this.observer.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Banner, {
        className: this.props.className || '',
        heading: this.props.heading,
        btnCopy: this.props.btnCopy,
        btnLink: this.props.btnLink,
        btnAttributes: this.props.btnAttributes,
        dataOp: this.props.dataOp,
        toHideCloseIcon: this.props.toHideCloseIcon,
        variant: this.props.variant,
        subCopy: this.props.subCopy,
        toClose: this.close,
        toShow: this.state.toShow,
        secondaryBtn: this.props.secondaryBtn,
        mainCTAclick: this.props.mainCTAclick
      });
    }
  }]);
}(React.Component);
export { StickyBanner as default };